import { EntityState } from '@/api/resources/entityState/entity-state'
import { commonStatusService } from '@/api/services/common/status/common-status.service'
import { EntityStatusState, StoreStateModel } from '@/store/root/root-store.model'
import { keyBy, merge } from 'lodash'
import { store } from '@/store/store'

export const ASSAY_STATES = {
    PENDING: { code: 'PENDING', class: 'state-pending', order: 10 },
    IN_PROCESS: { code: 'IN_PROCESS', class: 'state-process-1', order: 20 },
    CANCELED: { code: 'CANCELED', class: 'state-canceled', order: 30 },
    FINISHED: { code: 'FINISHED', class: 'state-success', order: 40 }
}

class AssayState extends EntityState {
    protected get entityName(): string {
        return 'assay'
    }

    async loadStates(): Promise<void> {
        if (!this.states.length) {
            const states = await commonStatusService.getAssayStates()
            const entityState: StoreStateModel<EntityStatusState[]> = {
                name: this.entityName,
                state: Object.values(
                    merge(
                        keyBy(states, 'code'),
                        keyBy(ASSAY_STATES, 'code')))
            }
            await store.dispatch('setEntityState', entityState)
        }
    }
}

export const assayState = new AssayState()
